import React, { useState } from 'react';
import { BsFacebook, BsInstagram, BsLinkedin, BsTwitter, BsYoutube } from 'react-icons/bs';
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoMdClose } from 'react-icons/io';
import { Link } from 'react-router-dom';


const Hadear1 = () => {
    const [ismobile, setIsmobile] = useState(0);
    return (
        <>

            <div>
                <button id="back-top" className="back-to-top">
                    <i className="far fa-arrow-up" />
                </button>
                {/* <div className="mouseCursor cursor-outer" />
                <div className="mouseCursor cursor-inner" /> */}
                <div className="fix-area">
                    <div className="offcanvas__info">
                        <div className="offcanvas__wrapper">
                            <div className="offcanvas__content">
                                <div className="offcanvas__top mb-5 d-flex justify-content-between align-items-center">
                                    <div className="offcanvas__logo">
                                        <Link to="/">
                                            <img src="assets/sa/Sudarshan Academy_logo.png" style={{ height: "100px", width: "100px" }} alt="logo-img" />
                                        </Link>
                                    </div>
                                    <div className="offcanvas__close">
                                        <button>
                                            <i className="fas fa-times" />
                                        </button>
                                    </div>
                                </div>
                                {/* <h3 className="offcanvas-title">Hello There!</h3> */}
                                {/* <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi natus quasi sunt eum ducimus. </p> */}
                                <div className="mobile-menu fix mt-3" />
                                <div className="social-icon d-flex align-items-center">
                                    <a href="https://www.instagram.com/sudarshanacademy/"><i className="fab fa-instagram" /></a>
                                    <a to="javascript:void(0)"><i className="fab fa-facebook-f" /></a>
                                    <a to="javascript:void(0)"><i className="fab fa-youtube" /></a>
                                </div>
                                <div className="offcanvas__contact">
                                    <h3>Contact Us</h3>
                                    <ul className="contact-list">
                                        <li>
                                            <div className="icon">
                                                <i className="far fa-phone-alt" />
                                            </div>
                                            <div className="content">
                                                <p>Call Us</p>
                                                <h4><a href="tel:+91 8878159423">+91 8878159423 </a></h4>
                                                <br />
                                                <h4><a href="tel:+91 9893806170">  +91 9893806170</a></h4>
                                            </div>
                                        </li>
                                        {/* <li>
                                            <div className="icon">
                                                <i className="fal fa-envelope" />
                                            </div>
                                            <div className="content">
                                                <p>Send Email</p>
                                                <h4><a to="mailto:yordomain@gmial.com">yordomain@gmial.com</a></h4>
                                            </div>
                                        </li> */}
                                        <li>
                                            <div className="icon">
                                                <i className="fal fa-map-marker-alt" />
                                            </div>
                                            <div className="content">
                                                <p>Location</p>
                                                <h4>
                                                    <a to='https://share.google/KkzqyENBtHYlkwyTz'>Abdul Kalam Azad Ward
                                                        <br />
                                                        No.12, Neemi Road, Satna (MP)</a>
                                                </h4>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <Link to="/contact" className="theme-btn">Admission Open <i className="icon-arrow-icon" /></Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="offcanvas__overlay" />
                <header className="header-section">
                    <div className="header-top-section">
                        <div className="header-shape">
                            <img src="assets/img/header1.png" alt="img" />
                        </div>
                        <div className="container">
                            <div className="header-top-wrapper">
                                {/* <p>Kindergarten is an early childhood educational environment <a to="contact.html">Learn More</a>
                                </p> */}
                                <marquee width="40%" direction="left" height="40px" style={{ color: "white" }}>
                                    Admission Open for New Session 2026-27 in Sudarshan Academy with the best facilities.
                                </marquee>
                                <ul className="header-contact-list">
                                    {/* <li>
                                        <i className="fal fa-envelope" />
                                        <a to="mailto:kidza@gmial.com">
                                            kidza@gmial.com
                                        </a>
                                    </li> */}
                                    <li style={{ color: "white" }}>
                                        <i className="far fa-phone-alt" />
                                        <a style={{ color: "white" }} href="tel:+91 8878159423">
                                            +91 8878159423, 9893806170
                                        </a>
                                    </li>
                                    <li style={{ color: "white" }}>
                                        <i className="fal fa-location" />
                                        <a style={{ color: "white" }} href='https://share.google/5xmmK8jd8FIbyph8F'>
                                            Abdul Kalam Azad Ward No.12, Neemi Road, Satna (MP)
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div id="header-sticky" className="header-1">
                        <div className="container">
                            <div className="mega-menu-wrapper">
                                <div className="header-main">
                                    <div className="header-left">
                                        <Link to="/" className="header-logo">
                                            <img src="assets/sa/Sudarshan Academy_logo.png" alt="img" style={{ height: "100px", width: "100px" }} />
                                        </Link>
                                    </div>
                                    <div className="mean__menu-wrapper">
                                        <div className="main-menu">
                                            <nav id="mobile-menu">
                                                <ul>
                                                    <li>
                                                        <Link to="/">
                                                            Home
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/about-us">
                                                            About Us
                                                            <i className="fas fa-chevron-down" />
                                                        </Link>
                                                        <ul className="submenu">
                                                            <li><Link to="/about-us">About Us</Link></li>
                                                            <li><Link to="/director-message">Director Message</Link></li>
                                                        </ul>
                                                    </li>
                                                    <li>
                                                        <Link to="/facility">
                                                            Facility
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/activities">
                                                            Activities
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/top-result">
                                                            Top Result
                                                        </Link>
                                                    </li>

                                                    <li>
                                                        <a to="/gallery">
                                                            Our Gallery
                                                            <i className="fas fa-chevron-down" />
                                                        </a>
                                                        <ul className="submenu">
                                                            <li><Link to="/gallery">Explore Our Photo</Link></li>
                                                            <li><Link to="/videos">Explore Our Videos</Link></li>
                                                        </ul>
                                                    </li>
                                                    <li>
                                                        <Link to="/blog">
                                                            Our Blog
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/contact">
                                                            Contact Us 
                                                        </Link>
                                                    </li>
                                                    
                                                    
                                                </ul>
                                            </nav>
                                        </div>
                                    </div>
                                    <div className="header-right d-flex justify-content-end align-items-center">
                                        <Link to="/contact" className="theme-btn">Admission Open <i className="icon-arrow-icon" /></Link>
                                        <div className="header__hamburger my-auto d-xl-none">
                                            <div className="sidebar__toggle">
                                                <i className="fal fa-bars" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <div className="search-popup">
                    <div className="search-popup__overlay search-toggler" />
                    <div className="search-popup__content">
                        <form role="search" method="get" className="search-popup__form" action="#">
                            <input type="text" id="search" name="search" placeholder="Search Here..." />
                            <button type="submit" aria-label="search submit" className="search-btn">
                                <span><i className="far fa-search" /></span>
                            </button>
                        </form>
                    </div>
                </div>
                <div id="targetElement" className="side_bar slideInRight side_bar_hidden">
                    <div className="side_bar_overlay" />
                    <div className="cart-title mb-50">
                        <h4>Shopping cart</h4>
                    </div>
                    <div className="cartmini__widget">
                        <div className="cartmini__widget-item">
                            <div className="cartmini__thumb">
                                <a to="shop-details.html">
                                    <img src="assets/img/shop-cart1.png" alt="img" />
                                </a>
                            </div>
                            <div className="cartmini__content">
                                <h5><a to="shop-details.html">Baby Bib Pink</a></h5>
                                <div className="cartmini__price-wrapper">
                                    <span className="cartmini__price">$46.00</span>
                                    <span className="cartmini__quantity">x2</span>
                                </div>
                            </div>
                            <button className="cartmini__del"><i className="fal fa-times" /></button>
                        </div>
                        <div className="cartmini__widget-item">
                            <div className="cartmini__thumb">
                                <a to="shop-details.html">
                                    <img src="assets/img/shop-cart2.png" alt="img" />
                                </a>
                            </div>
                            <div className="cartmini__content">
                                <h5><a to="shop-details.html">Plastic Roller Mop</a></h5>
                                <div className="cartmini__price-wrapper">
                                    <span className="cartmini__price">$78.00</span>
                                    <span className="cartmini__quantity">x1</span>
                                </div>
                            </div>
                            <button className="cartmini__del"><i className="fal fa-times" /></button>
                        </div>
                        <div className="cartmini__checkout">
                            <div className="cartmini__checkout-title mb-4">
                                <h4>Subtotal:</h4>
                                <span>$113.00</span>
                            </div>
                            <div className="cartmini__checkout-btn">
                                <a to="shop-cart.html" className="theme-btn mb-2 w-100"> view cart</a>
                                <a to="checkout.html" className="theme-btn w-100 style-2"> checkout</a>
                            </div>
                        </div>
                    </div>
                    <button id="closeButton" className="x-mark-icon"><i className="fas fa-times" /></button>
                </div>
            </div>


        </>
    )
}
export default Hadear1